import { ChakraProvider, createSystem, defaultConfig, defineConfig } from "@chakra-ui/react";
import { jsx } from "react/jsx-runtime";
// src/provider/theme.ts
const customConfig = defineConfig({
	theme: {
		tokens: { colors: {
			brand: {
				50: { value: "#e3f6f7" },
				100: { value: "#c1eaeb" },
				200: { value: "#9ddedf" },
				300: { value: "#77d2d4" },
				400: { value: "#4fc6c8" },
				500: { value: "#26babe" },
				600: { value: "#0b7678" },
				700: { value: "#095a5c" },
				800: { value: "#073f40" },
				900: { value: "#042526" },
				950: { value: "#021414" }
			},
			shell: { value: "#04453B" }
		} },
		semanticTokens: { colors: { brand: {
			contrast: { value: {
				_light: "white",
				_dark: "white"
			} },
			fg: { value: {
				_light: "{colors.brand.700}",
				_dark: "{colors.brand.300}"
			} },
			subtle: { value: {
				_light: "{colors.brand.100}",
				_dark: "{colors.brand.900}"
			} },
			muted: { value: {
				_light: "{colors.brand.200}",
				_dark: "{colors.brand.800}"
			} },
			emphasized: { value: {
				_light: "{colors.brand.300}",
				_dark: "{colors.brand.700}"
			} },
			solid: { value: {
				_light: "{colors.brand.600}",
				_dark: "{colors.brand.600}"
			} },
			focusRing: { value: {
				_light: "{colors.brand.500}",
				_dark: "{colors.brand.500}"
			} },
			border: { value: {
				_light: "{colors.brand.500}",
				_dark: "{colors.brand.400}"
			} }
		} } }
	},
	globalCss: { html: { colorPalette: "brand" } }
});
const system = createSystem(defaultConfig, customConfig);
// src/provider/provider.tsx
function Provider({ children }) {
	return /* @__PURE__ */ jsx(ChakraProvider, {
		value: system,
		children
	});
}
export { Provider };

//# sourceMappingURL=index.js.map